export const SET_LABS_FILTERS = "SET_LABS_FILTERS";
export const RESET_LABS_FILTERS = "RESET_LABS_FILTERS";

export const setLabsFilters = (payload) => ({ type: SET_LABS_FILTERS, payload });
export const resetLabsFilters = () => ({ type: RESET_LABS_FILTERS });
